module.exports = __webpack_public_path__ + "static/media/DarkFae2.4368ec26.png";